export type ValidationType = {
  content: string
  type: string
}
export type ConfidenceAndValidationsType = {
  confidence: number
  validations: ValidationType[]
}

export const ConfidenceAndValidationMappings = {
  weight: {
    UnitDoesNotMatchPattern: 'Unexpected unit',
    UnitUnknown: 'Unknown unit',
    UnitUncertain: 'Uncertain unit',
    WeightExpected: 'Weight expected'
  },
  deliveryArrivalDate: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  deliveryArrivalDateUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  removalDate: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  removalDateUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  removalExitDate: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  removalExitDateUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  deliveryExitDate: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  deliveryExitDateUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  productionTime: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  productionTimeUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  usedAtTime: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  },
  usedAtTimeUS: {
    CouldntParseDateTime: 'Could not convert raw Date/Time to a valid value',
    CouldntParseDate:
      'Raw field for Date could not be converted to a valid Date',
    CouldntParseTime:
      'Raw field for Time could not be converted to a valid Time'
  }
}

export const CONFIDENCE_AND_VALIDATION_TYPES = {
  ATTENTION: 'Attention',
  INFORMATION: 'Information',
  WARNING: 'Warning',
  ERROR: 'Error',
  HIGH_CONFIDENCE: 'High-Confidence'
}

// Determine validation type based on confidence value
export const CONFIDENCE_BASED_TYPE = (value: number) => {
  if (value >= 0.75) {
    return CONFIDENCE_AND_VALIDATION_TYPES.HIGH_CONFIDENCE
  } else if (value >= 0.5 && value < 0.75) {
    return CONFIDENCE_AND_VALIDATION_TYPES.WARNING
  } else {
    return CONFIDENCE_AND_VALIDATION_TYPES.ATTENTION
  }
}
